import React from 'react'
import TableOne from './Tabels/TableOne'
function DataTableComponentExample() {
    return (
        <div className='page-body'>
            <TableOne />
        </div>

    )
}

export default DataTableComponentExample